module.exports = __webpack_public_path__ + "img/center back length to empire seam.43b9d885.png";